import React, { useEffect, useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";

// Define a utility to get the base URL depending on the origin
const getBaseUrl = (): string => {
  const origin = window.location.origin; // get current origin (protocol + host)

  if (origin.includes("local") || origin.includes("dev")) {
    return "https://atsapp-dev.glorri.com"; // Development base URL
  } else {
    return "https://atsapp.glorri.com"; // Production base URL
  }
};

// Axios instance configuration
const api = axios.create({
  baseURL: getBaseUrl(),
});

// Add a request interceptor
api.interceptors.request.use(
  (config: any) => {
    // Check if token exists in localStorage
    const token = localStorage.getItem("token");
    // If token exists, add it to the Authorization header
    if (token) {
      config.headers["x-auth-token"] = token;
    }

    return config;
  },
  (error) => {
    // Handle request errors (optional)
    return Promise.reject(error);
  }
);

// Add an Axios interceptor for handling 401 Unauthorized errors
api.interceptors.response.use(
  (response: AxiosResponse) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    // If the error is 401 Unauthorized, clear the token and redirect to login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token"); // Remove token from localStorage
      window.location.href = "/"; // Redirect to login page (you can also use useHistory here for React Router)
    }
    return Promise.reject(error);
  }
);

// React component
export class BaseApi {
  // GET Request example
  public async fetchData(url: string) {
    try {
      const response: AxiosResponse = await api.get(url); // Replace with your API endpoint
      return response;
    } catch (err: any) {
      console.error(err);
    }
  }
  


  // POST Request example
  public async postData(url: string, data: any) {
    try {
      const response: AxiosResponse = await api.post(url, data);
      console.log(response.data);
      
      return response;
    } catch (err: any) {
      console.error(err);
    }
  }

  public async putData(url: string, data: any) {
    try {
      const response: AxiosResponse = await api.put(url, data);
      return response;
    } catch (err: any) {
      console.error(err);
    }
  }
  public async patchData(url: string) {
    try {
      const response: AxiosResponse = await api.patch(url);
      console.log(response);
      
      return response;
    } catch (err: any) {
      console.error(err);
    }
  }

  public async deleteData(url: string): Promise<AxiosResponse | void> {
    try {
      const response: AxiosResponse = await api.delete(url);
      console.log(response);
      
      return response;
    } catch (err: AxiosError | any) {
      console.error(err);
    }
  }
}
